/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CreatePaymentMethodSetupSessionResponseData } from './CreatePaymentMethodSetupSessionResponseData';
import {
    CreatePaymentMethodSetupSessionResponseDataFromJSON,
    CreatePaymentMethodSetupSessionResponseDataFromJSONTyped,
    CreatePaymentMethodSetupSessionResponseDataToJSON,
    CreatePaymentMethodSetupSessionResponseDataToJSONTyped,
} from './CreatePaymentMethodSetupSessionResponseData';

/**
 * 
 * @export
 * @interface CreatePaymentMethodSetupSessionResponse
 */
export interface CreatePaymentMethodSetupSessionResponse {
    /**
     * 
     * @type {CreatePaymentMethodSetupSessionResponseData}
     * @memberof CreatePaymentMethodSetupSessionResponse
     */
    data: CreatePaymentMethodSetupSessionResponseData;
}

/**
 * Check if a given object implements the CreatePaymentMethodSetupSessionResponse interface.
 */
export function instanceOfCreatePaymentMethodSetupSessionResponse(value: object): value is CreatePaymentMethodSetupSessionResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function CreatePaymentMethodSetupSessionResponseFromJSON(json: any): CreatePaymentMethodSetupSessionResponse {
    return CreatePaymentMethodSetupSessionResponseFromJSONTyped(json, false);
}

export function CreatePaymentMethodSetupSessionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatePaymentMethodSetupSessionResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': CreatePaymentMethodSetupSessionResponseDataFromJSON(json['data']),
    };
}

  export function CreatePaymentMethodSetupSessionResponseToJSON(json: any): CreatePaymentMethodSetupSessionResponse {
      return CreatePaymentMethodSetupSessionResponseToJSONTyped(json, false);
  }

  export function CreatePaymentMethodSetupSessionResponseToJSONTyped(value?: CreatePaymentMethodSetupSessionResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': CreatePaymentMethodSetupSessionResponseDataToJSON(value['data']),
    };
}

